const Game = {
  RESET_GAME: 'RESET_GAME',
  RESET_PERMUTATION: 'RESET_PERMUTATION',
  ADD_BEAR_TO_SOFA: 'ADD_BEAR_TO_SOFA',
  ADD_BEAR_TO_START: 'ADD_BEAR_TO_START',
  REMOVE_BEAR_FROM_SOFA: 'REMOVE_BEAR_FROM_SOFA',
  REMOVE_BEAR_FROM_START: 'REMOVE_BEAR_FROM_START',
  SAVE_PERMUTATION: 'SAVE_PERMUTATION',
  INIT_BEARS: 'INIT_BEARS',
  INIT_SOFA: 'INIT_SOFA',
  REDIRECT_TO_RESULT_VIEW: 'REDIRECT_TO_RESULT_VIEW',
  REDIRECT_TO_START_VIEW: 'REDIRECT_TO_START_VIEW'
}

const Settings = {
  RESET_SETTINGS: 'RESET_SETTINGS',
  INCREASE_NUMBER_OF_SEATS: 'INCREASE_NUMBER_OF_SEATS',
  DECREASE_NUMBER_OF_SEATS: 'DECREASE_NUMBER_OF_SEATS',
  INCREASE_NUMBER_OF_BEARS: 'INCREASE_NUMBER_OF_BEARS',
  DECREASE_NUMBER_OF_BEARS: 'DECREASE_NUMBER_OF_BEARS',
  UPDATE_BEAR: 'UPDATE_BEAR',
  DELETE_BEAR: 'DELETE_BEAR',
  START_GAME: 'START_GAME',
  BACK_TO_GAME: 'BACK_TO_GAME',
  SAVE_LAST_SETTINGS: 'SAVE_LAST_SETTINGS'
}

const ActionTypes = Object.assign({}, Game, Settings )

export const ActionTypesGame = Object.freeze( Game )
export const ActionTypesSettings = Object.freeze( Settings )
export default Object.freeze( ActionTypes )



/** WEBPACK FOOTER **
 ** ./src/app/redux/actions/actionTypes.js
 **/